import {LedApiFeature} from 'pikaparam';

export const LED_API_VERSIONS: LedApiFeature[] = [
  'led-api-1',
  'led-api-2',
  'led-api-3',
];
